/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { ClosedEnum } from "../types/enums.js";

/**
 * 查询的数据源。如果留空，将使用默认的数据库。如果设置为 `commercial`，将调用商业级API，返回更详细的地理位置信息，但响应时间可能会稍长。
 */
export const GetNetworkIpinfoSource = {
  Commercial: "commercial",
} as const;
/**
 * 查询的数据源。如果留空，将使用默认的数据库。如果设置为 `commercial`，将调用商业级API，返回更详细的地理位置信息，但响应时间可能会稍长。
 */
export type GetNetworkIpinfoSource = ClosedEnum<typeof GetNetworkIpinfoSource>;

export const GetNetworkIpinfoSource$zodSchema = z.enum([
  "commercial",
]).describe(
  "查询的数据源。如果留空，将使用默认的数据库。如果设置为 `commercial`，将调用商业级API，返回更详细的地理位置信息，但响应时间可能会稍长。",
);

export type GetNetworkIpinfoRequest = {
  ip: string;
  source?: GetNetworkIpinfoSource | undefined;
};

export const GetNetworkIpinfoRequest$zodSchema: z.ZodType<
  GetNetworkIpinfoRequest
> = z.object({
  ip: z.string().describe("你需要查询的公网IP地址或域名（支持IPv4和IPv6）。"),
  source: GetNetworkIpinfoSource$zodSchema.optional(),
});

export type GetNetworkIpinfoInternalServerErrorDetails = {};

export const GetNetworkIpinfoInternalServerErrorDetails$zodSchema: z.ZodType<
  GetNetworkIpinfoInternalServerErrorDetails
> = z.object({});

/**
 * 服务器内部错误。IP查询服务可能遇到了问题。
 */
export type GetNetworkIpinfoInternalServerErrorResponseBody = {
  code?: string | undefined;
  details?: GetNetworkIpinfoInternalServerErrorDetails | undefined;
  message?: string | undefined;
};

export const GetNetworkIpinfoInternalServerErrorResponseBody$zodSchema:
  z.ZodType<GetNetworkIpinfoInternalServerErrorResponseBody> = z.object({
    code: z.string().optional(),
    details: z.lazy(() => GetNetworkIpinfoInternalServerErrorDetails$zodSchema)
      .optional(),
    message: z.string().optional(),
  }).describe("服务器内部错误。IP查询服务可能遇到了问题。");

export type GetNetworkIpinfoNotFoundDetails = {};

export const GetNetworkIpinfoNotFoundDetails$zodSchema: z.ZodType<
  GetNetworkIpinfoNotFoundDetails
> = z.object({});

/**
 * 信息未找到。这通常意味着你查询的是一个内网IP地址（如 192.168.x.x）或一个未分配的公网IP地址，我们的数据库中没有它的信息。
 */
export type GetNetworkIpinfoNotFoundResponseBody = {
  code?: string | undefined;
  details?: GetNetworkIpinfoNotFoundDetails | undefined;
  message?: string | undefined;
};

export const GetNetworkIpinfoNotFoundResponseBody$zodSchema: z.ZodType<
  GetNetworkIpinfoNotFoundResponseBody
> = z.object({
  code: z.string().optional(),
  details: z.lazy(() => GetNetworkIpinfoNotFoundDetails$zodSchema).optional(),
  message: z.string().optional(),
}).describe(
  "信息未找到。这通常意味着你查询的是一个内网IP地址（如 192.168.x.x）或一个未分配的公网IP地址，我们的数据库中没有它的信息。",
);

export type GetNetworkIpinfoBadRequestDetails = {};

export const GetNetworkIpinfoBadRequestDetails$zodSchema: z.ZodType<
  GetNetworkIpinfoBadRequestDetails
> = z.object({});

/**
 * IP地址参数无效。请检查 `ip` 参数是否提供，以及它是否是一个合法的公网IP地址。
 */
export type GetNetworkIpinfoBadRequestResponseBody = {
  code?: string | undefined;
  details?: GetNetworkIpinfoBadRequestDetails | undefined;
  message?: string | undefined;
};

export const GetNetworkIpinfoBadRequestResponseBody$zodSchema: z.ZodType<
  GetNetworkIpinfoBadRequestResponseBody
> = z.object({
  code: z.string().optional(),
  details: z.lazy(() => GetNetworkIpinfoBadRequestDetails$zodSchema).optional(),
  message: z.string().optional(),
}).describe(
  "IP地址参数无效。请检查 `ip` 参数是否提供，以及它是否是一个合法的公网IP地址。",
);

/**
 * 查询成功！返回该IP地址的详细地理和网络信息。
 */
export type GetNetworkIpinfoResponseBody = {
  ip?: string | undefined;
  region?: string | undefined;
  isp?: string | undefined;
  llc?: string | undefined;
  asn?: string | undefined;
  latitude?: number | undefined;
  longitude?: number | undefined;
  beginip?: string | undefined;
  endip?: string | undefined;
  district?: string | undefined;
};

export const GetNetworkIpinfoResponseBody$zodSchema: z.ZodType<
  GetNetworkIpinfoResponseBody
> = z.object({
  asn: z.string().optional(),
  beginip: z.string().optional(),
  district: z.string().optional(),
  endip: z.string().optional(),
  ip: z.string().optional(),
  isp: z.string().optional(),
  latitude: z.number().optional(),
  llc: z.string().optional(),
  longitude: z.number().optional(),
  region: z.string().optional(),
}).describe("查询成功！返回该IP地址的详细地理和网络信息。");

export type GetNetworkIpinfoResponse =
  | GetNetworkIpinfoResponseBody
  | GetNetworkIpinfoBadRequestResponseBody
  | GetNetworkIpinfoNotFoundResponseBody
  | GetNetworkIpinfoInternalServerErrorResponseBody;

export const GetNetworkIpinfoResponse$zodSchema: z.ZodType<
  GetNetworkIpinfoResponse
> = z.union([
  z.lazy(() => GetNetworkIpinfoResponseBody$zodSchema),
  z.lazy(() => GetNetworkIpinfoBadRequestResponseBody$zodSchema),
  z.lazy(() => GetNetworkIpinfoNotFoundResponseBody$zodSchema),
  z.lazy(() => GetNetworkIpinfoInternalServerErrorResponseBody$zodSchema),
]);
